"use strict";
/* istanbul ignore file */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.zaraz = void 0;
const consent_1 = require("./consent");
const ecommerce_1 = require("./ecommerce");
const set_1 = require("./set");
const track_1 = require("./track");
exports.zaraz = {
    track: track_1.track,
    set: set_1.set,
    ecommerce: ecommerce_1.ecommerce,
    consent: consent_1.consent,
};
// Export typing etc.
__exportStar(require("./consent"), exports);
__exportStar(require("./ecommerce"), exports);
__exportStar(require("./set"), exports);
__exportStar(require("./track"), exports);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLDBCQUEwQjs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFFMUIsdUNBQW9DO0FBQ3BDLDJDQUF3QztBQUN4QywrQkFBNEI7QUFDNUIsbUNBQWdDO0FBU25CLFFBQUEsS0FBSyxHQUFHO0lBQ25CLEtBQUssRUFBTCxhQUFLO0lBQ0wsR0FBRyxFQUFILFNBQUc7SUFDSCxTQUFTLEVBQVQscUJBQVM7SUFDVCxPQUFPLEVBQVAsaUJBQU87Q0FDUixDQUFDO0FBRUYscUJBQXFCO0FBQ3JCLDRDQUEwQjtBQUMxQiw4Q0FBNEI7QUFDNUIsd0NBQXNCO0FBQ3RCLDBDQUF3QiJ9